import React from "react";
import { graphql, Link } from "gatsby";
import Seo from "../components/Seo";
import parse from "html-react-parser";
import "../styles/blog.css";

const PodcastTemplate = ({ data }) => {
  return (
    <div className="max-w-screen-lg mx-auto mt-6">
      <Seo title={data.shopifyArticle.title} />
      <Link
        to="/blogs/podcast"
        className="text-gray-light border-b p-2 mx-6 lg:mx-0"
      >
        &lt; Back to Episodes
      </Link>
      <h1 className="px-6 mt-8 lg:px-0 text-25 lg:text-35 max-w-xl text-gray mb-4">
        {data.shopifyArticle.title}
      </h1>
      <p className="px-6 lg:px-0 mb-6 max-w-xl">
        {data.shopifyArticle.excerpt}
      </p>
      <div className="blogContent">
        {parse(data.shopifyArticle.contentHtml)}
      </div>
    </div>
  );
};

export default PodcastTemplate;

export const query = graphql`
  query ($handle: String!) {
    shopifyArticle(handle: { eq: $handle }) {
      handle
      title
      excerpt
      contentHtml
      publishedAt
    }
  }
`;
